/* global autosize */
import PrintavoModal from "../modal_controller";

export default class extends PrintavoModal {
  static targets = ["group", "notesIcon", "notesView", "poNote", "receivingNotesTextbox", "editNotesButton"];

  static values = {
    addNotes: String,
    editNotes: String,
  };

  show() {
    this.receivingNotesTextboxTarget.value = this.notesViewTarget.textContent;
    this.groupTarget.dataset.toggleOpenValue = "true";
    this.syncViewWithTextbox();
  }

  autosizeTextboxes() {
    autosize.update(this.receivingNotesTextboxTarget);
    setTimeout(() => autosize(this.receivingNotesTextboxTarget));
  }

  focusTextbox() {
    setTimeout(() => this.receivingNotesTextboxTarget.focus());
  }

  syncViewWithTextbox() {
    this.notesViewTarget.textContent = this.receivingNotesTextboxTarget.value;

    if (this.empty()) {
      this.notesViewTarget.textContent = "";
      this.editNotesButtonTarget.textContent = this.addNotesValue;
    } else {
      this.editNotesButtonTarget.textContent = this.editNotesValue;
    }

    this.updateIcon();
  }

  saved() {
    this.syncViewWithTextbox();
    this.updateIcon();
  }

  empty() {
    return /^\s*$/.test(this.notesViewTarget.textContent);
  }

  updateIcon() {
    const hasNotesOfAnyKind = !this.empty() || this.hasPoNoteTarget;

    this.notesIconTarget.classList.toggle("far", !hasNotesOfAnyKind);
    this.notesIconTarget.classList.toggle("fas", hasNotesOfAnyKind);
    this.notesIconTarget.closest("button").classList.toggle("bg-white", hasNotesOfAnyKind);
  }
}
